import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Convert relative /api paths returned by the backend (e.g. /api/media/file/...)
// into fully-qualified URLs that work from the frontend.
export const resolveUrl = (url) => {
  if (!url) return "";
  if (url.startsWith("http")) return url;
  if (url.startsWith("/api")) return `${BACKEND_URL}${url}`;
  return url;
};

export const fetchMedia = async () => {
  const { data } = await axios.get(`${API}/media`);
  return data;
};

export const fetchHero = async (limit = 4) => {
  const { data } = await axios.get(`${API}/media/hero?limit=${limit}`);
  return Array.isArray(data) ? data : (data ? [data] : []);
};

export const setHero = async (token, id) => {
  const { data } = await axios.post(`${API}/admin/media/${id}/set-hero`, {}, { headers: authHeaders(token) });
  return data;
};

export const reconvertHeic = async (token) => {
  const { data } = await axios.post(`${API}/admin/media/reconvert-heic`, {}, { headers: authHeaders(token) });
  return data;
};

export const reconvertStatus = async (token) => {
  const { data } = await axios.get(`${API}/admin/media/reconvert-heic/status`, { headers: authHeaders(token) });
  return data;
};

export const reclassify = async (token, scope = "both") => {
  const { data } = await axios.post(`${API}/admin/media/reclassify?scope=${scope}`, {}, { headers: authHeaders(token) });
  return data;
};

export const reclassifyStatus = async (token) => {
  const { data } = await axios.get(`${API}/admin/media/reclassify/status`, { headers: authHeaders(token) });
  return data;
};

export const scanSolo = async (token) => {
  const { data } = await axios.post(`${API}/admin/media/scan-solo`, {}, { headers: authHeaders(token) });
  return data;
};

export const scanSoloStatus = async (token) => {
  const { data } = await axios.get(`${API}/admin/media/scan-solo/status`, { headers: authHeaders(token) });
  return data;
};

export const login = async (passcode) => {
  const { data } = await axios.post(`${API}/admin/login`, { passcode });
  return data.token;
};

const authHeaders = (token) => ({ Authorization: `Bearer ${token}` });

export const createMedia = async (token, payload) => {
  const { data } = await axios.post(`${API}/admin/media`, payload, { headers: authHeaders(token) });
  return data;
};

export const updateMedia = async (token, id, patch) => {
  const { data } = await axios.patch(`${API}/admin/media/${id}`, patch, { headers: authHeaders(token) });
  return data;
};

export const deleteMedia = async (token, id) => {
  await axios.delete(`${API}/admin/media/${id}`, { headers: authHeaders(token) });
};

export const uploadFile = async (token, file, onProgress) => {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await axios.post(`${API}/admin/media/upload`, fd, {
    headers: { ...authHeaders(token), "Content-Type": "multipart/form-data" },
    onUploadProgress: (e) => {
      if (onProgress && e.total) onProgress(Math.round((e.loaded / e.total) * 100));
    },
  });
  return data;
};

export const bulkUpload = async (token, files, onProgress) => {
  const fd = new FormData();
  files.forEach((f) => fd.append("files", f));
  const { data } = await axios.post(`${API}/admin/media/bulk`, fd, {
    headers: { ...authHeaders(token), "Content-Type": "multipart/form-data" },
    onUploadProgress: (e) => {
      if (onProgress && e.total) onProgress(Math.round((e.loaded / e.total) * 100));
    },
    timeout: 600000, // 10 min for classification
  });
  return data;
};

export const seedMedia = async (token) => {
  const { data } = await axios.post(`${API}/admin/seed`, {}, { headers: authHeaders(token) });
  return data;
};
